// Messages for operator/companies/ApiAccessBadge (auto-merged by lib/i18n.ts).
export const en = {
  'operator.api_access.enabled': 'Enabled',
  'operator.api_access.disabled': 'Disabled',
  'operator.api_access.blocked': 'Blocked',
}

export const zhTW = {
  'operator.api_access.enabled': '已啟用',
  'operator.api_access.disabled': '已停用',
  'operator.api_access.blocked': '已封鎖',
}
